import { createAction } from "redux-actions";
import { moduleSlug } from "modules/ConfigCI/services/constants";

export const clearConfigCITests = createAction(`${moduleSlug}/CLEAR_CONFIG_CI_TESTS`);

export const getConfigCITests = createAction(`${moduleSlug}/GET_CONFIG_CI_TESTS`);
export const getConfigCITestsSuccess = createAction(`${moduleSlug}/GET_CONFIG_CI_TESTS/SUCCESS`);
export const getConfigCITestsError = createAction(`${moduleSlug}/GET_CONFIG_CI_TESTS/ERROR`);

export const setTestCases = createAction(`${moduleSlug}/SET_TEST_CASES`);
export const mergeTestCases = createAction(`${moduleSlug}/MERGE_TEST_CASES`);

export const testCaseCancel = createAction(`${moduleSlug}/TEST_CASE_CANCEL`);
